// extracted by mini-css-extract-plugin
module.exports = {"container":"Reader__container--Gf6bK7vpqI","header":"Reader__header--2nEirELhuH"};